import { render } from "./WalletBanner.vue?vue&type=template&id=44b0f553&scoped=true&ts=true"
import script from "./WalletBanner.vue?vue&type=script&lang=ts"
export * from "./WalletBanner.vue?vue&type=script&lang=ts"

import "./WalletBanner.vue?vue&type=style&index=0&id=44b0f553&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b0f553"]])

export default __exports__